const initialState = {
  loading: false,
  mmosUser: [],
  count: 0,
  selectedUser: {},
};

const mmosUsersReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "GET_MMOSUSER_DATA": {
      return {
        ...state,
        loading: actions.loading,
        mmosUser: actions.data,
        count: actions.data.length,
      };
    }
    case "LOADING_MMOS": {
      return {
        ...state,
        loading: actions.loading,
      };
    }
    case "CLEAR_MMOSUSER_DATA": {
      return {
        ...state,
        loading: actions.loading,
        mmosUser: [],
      };
    }
    case "SELECTED_USER": {
      return {
        ...state,
        loading: actions.loading,
        selectedUser: actions.data,
      };
    }

    // case "UPDATE_LESSON": {
    //   return { ...state, lessons: actions.data };
    // }
    // case "GET_LESSONS_BY_GROUP": {
    //   return { ...state, lessonsByGroup: actions.data };
    // }
    // case "CLEAR_LESSON": {
    //   return { ...state, lessonsByGroup: [] };
    // }
    default:
      return state;
  }
};
export default mmosUsersReducer;
